import getSharingLink from '../selectors/getSharingLink';
import SharingLinkInfo from '../store/schema/SharingLinkInfo';
import { getAttachmentPermissionLevelFromSharingLinkKind } from 'owa-attachment-permission';
import { mutator } from 'satcheljs';
import {
    updateSharingLinkFromSharingDialog,
    updateSharePointLinkPermission,
} from '../actions/internalActions';

mutator(updateSharingLinkFromSharingDialog, actionMessage => {
    const sharingLink: SharingLinkInfo = getSharingLink(actionMessage.linkId);

    const permissionLevel = getAttachmentPermissionLevelFromSharingLinkKind(
        actionMessage.sharingDialogResponse.linkKind
    );
    sharingLink.permissionLevel = permissionLevel;
});

mutator(updateSharePointLinkPermission, actionMessage => {
    const sharingLink: SharingLinkInfo = getSharingLink(actionMessage.linkId);
    sharingLink.permissionLevel = actionMessage.newPermission;
});
